export default __webpack_public_path__ + "static/fuse-a99ad70a147672f5332481c6d2c6cc5d.mp3";